'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Games = void 0;
var tslib_1 = require("tslib");
var transport_1 = require("../../transport");
var Games = /** @class */ (function () {
    function Games() {
    }
    Games.prototype.fetch = function (url) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var content, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, transport_1.transport.getHttpDriver().get(url)];
                    case 1:
                        content = _a.sent();
                        return [2 /*return*/, JSON.parse(content)];
                    case 2:
                        e_1 = _a.sent();
                        console.error('Could not fetch games list from', url, e_1);
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Games.prototype.getLastPlayedGames = function (params) {
        return transport_1.transport.request('users/getLastGamesPlayed', params);
    };
    Games.prototype.getRecentWinners = function (params) {
        return transport_1.transport.request('games/getRecentWinners', params);
    };
    Games.prototype.jackpots = function (params) {
        return transport_1.transport.request('games/jackpots', params);
    };
    Games.prototype.getFavourites = function () {
        return transport_1.transport.request('games/getFavourites');
    };
    Games.prototype.launchUrl = function (params) {
        return transport_1.transport.request('games/launchUrl', params);
    };
    Games.prototype.checkForActiveSessions = function () {
        return transport_1.transport.request('games/checkForActiveSessions');
    };
    Games.prototype.checkForCorexActiveSessions = function () {
        return transport_1.transport.request('corex/get-user-session-contexts');
    };
    Games.prototype.deleteActiveSessions = function (params) {
        var isCorex = transport_1.transport.isCoreX();
        if (!isCorex) {
            return transport_1.transport.request('games/deleteActiveSessions', params);
        }
        else {
            return Promise.resolve();
        }
    };
    Games.prototype.browser = function (params) {
        return transport_1.transport.request('games/browser', params);
    };
    Games.prototype.favourite = function (params) {
        return transport_1.transport.request('games/favourite', params);
    };
    Games.prototype.getRecommendedGames = function (params) {
        return transport_1.transport.request('games/getRecommendedGames', params);
    };
    Games.prototype.getGREMarketRecommendations = function (params) {
        return transport_1.transport.request('games/getGREMarketRecommendations', params);
    };
    Games.prototype.getDynamicUserRecommendedCategory = function (params) {
        return transport_1.transport.request('games/getGREUserRecommendations', params);
    };
    Games.prototype.getGRESimilarGameRecommendations = function (params) {
        return transport_1.transport.request('games/getGRESimilarGameRecommendations', params);
    };
    Games.prototype.getLaunchGameUrl = function (params) {
        return transport_1.transport.request('corex/get-launch-game-url', params);
    };
    Games.prototype.getDemoLaunchGameUrl = function (params) {
        return transport_1.transport.request('corex/get-demo-launch-game-url', params);
    };
    return Games;
}());
exports.Games = Games;
